/**
 * Return true if the object is null
 * @param obj
 * @returns {boolean}
 */
// const {NassauLog} = require("./myga-utils");

const isNull = (obj) => {
  return obj === null;
};

/**
 * Return true if the object is undefined
 * @param obj
 * @returns {boolean}
 */
const isUndefined = (obj) => {
  return obj === void 0;
};

/**
 * Returns true if the oject is neither null nor undefined
 * @param obj
 * @returns {boolean|boolean}
 */
const isValid = (obj) => {
  return (!isNull(obj) && !isUndefined(obj));
};


/**
 * Master product specification.  Not to be confused with a cart item.
 * @type {Readonly<{calculator: string, themeCss: string, productID: string, title: string, productType: string, enabled: string, logoUrl: string}>}
 * @private
 */
const _PRODUCT = Object.freeze({
  
  /**
   * Unique product ID
   */
  productID : "productID",
  
  /**
   * Product family identifier (i.e., simple annuity, my annuity).
   */
  productFamily : "productFamily",
  
  /**
   * product type indicating information and calculation features
   * for example (myga, fia)
   */
  productType: "productType",
  
  /**
   * separate product name for UI display
   */
  productName: "productName",
  
  /**
   * product brand (i.e., NFG, other sellers)
   */
  productBrand: "productBrand",
  
  /**
   * product calculation controls and information
   */
  calculator: "calculator",
  
  /**
   * Product visual elements
   */
  visuals : "visuals",
  
  /**
   * customization state (true/FALSE)
   */
  customized : "customized",
  
  /**
   * user modified (true/FALSE)
   */
  userModified: "userModified",
  
  /**
   * An array of keywords to use for product searches
   */
  keywords : "keywords",
  
  /**
   * Reference to the DTO associated with this prodcut
   */
  dto: "dto",
  
  // Questions
  // specifies an array of question IDS to be associated with this product
  questions: "questions"
  
});
export const MM_PRODUCT = _PRODUCT;

const _PRODUCT_ID = Object.freeze({
  nfgSA0405 : "nfgSA0405",
  nfgSA0605 : "nfgSA0605",
  nfgMA0500 : "nfgMA0500",
  nfgMA0700 : "nfgMA0700",
  nfgMA0510 : "nfgMA0510",
  nfgMA0710 : "nfgMA0710"
});
export const MM_PRODUCT_ID = _PRODUCT_ID;

const _PRODUCT_TYPE = Object.freeze({
  /**
   * @deprecated - simpleAnnuity use myga instead
   */
  simpleAnnuity: "simpleAnnuity",
  /**
   * New product type for MYGA
   */
  myga: "myga",
  
  fia: "fia"
  
  // add other product types here.
});
export const MM_PRODUCT_TYPE = _PRODUCT_TYPE;

const _PRODUCT_FAMILY = Object.freeze({
  nfgSA: "nfgSA",
  nfgMA: "nfgMA"
});
export const MM_PRODUCT_FAMILY = _PRODUCT_FAMILY;

const _PRODUCT_FAMILY_RATE_FILE = Object.freeze({
  [_PRODUCT_FAMILY.nfgMA] : "rates-myannuity.json",
  [_PRODUCT_FAMILY.nfgSA] : "rates-myga.json",
});
export const PRODUCT_FAMILY_RATE_FILE = _PRODUCT_FAMILY_RATE_FILE;

const _CALCULATOR_TYPE = Object.freeze({
  myga: "myga"
});
export const MM_CALCULATOR_TYPE = _CALCULATOR_TYPE;

// 2022.05.10.ADivelbiss - added to support the APP_SECTIONS.products
const _PRODUCT_DTO = Object.freeze({
  productID : "productID",
  productFamily : "productFamily",
  productType: "productType",
  premium: "premium",
  rate: "rate",
  surrenderPeriod: "surrenderPeriod",
  freeWithdrawalAmount: "freeWithdrawalAmount",
  parties: "parties",
  benes: "benes",
  payments: "payments",
});
export const MM_PRODUCT_DTO = _PRODUCT_DTO;


const _CALCULATOR = Object.freeze({
  // type
  calculatorType: "calculatorType",
  
  // calculator functions
  calculateInterest: "calculateInterest",
  calculateValue: "calculateValue",
  
  // myga rate (from api)
  rate: "rate",
  
  // Premium Values
  premium: "premium",
  premiumMin: "premiumMin",
  premiumMax: "premiumMax",
  
  // surrenderPeriod used for calculations
  surrenderPeriod: "surrenderPeriod",
  
  freeWithdrawalAmount: "freeWithdrawalAmount",
  
});
export const MM_CALCULATOR = _CALCULATOR;

const _PRODUCT_VISUALS = Object.freeze({
  enabled: "enabled",
  title: "title",
  info: "info",
  tradeMark: "tradeMark",
  surrenderPeriod: "surrenderPeriod",
  surrenderPeriodLabel: "surrenderPeriodLabel",
  freeWithdrawalAmount: "freeWithdrawalAmount",
  withdrawalRateInfo: "withdrawalRateInfo",
  logoUrl: "logoUrl",
  themeCss: "themeCss",
  cardColor: "cardColor",
  cardColorDefault: "cardColorDefault",
  importantDisclosures: "importantDisclosures",
});
export const MM_PRODUCT_VISUALS = _PRODUCT_VISUALS;

// 2022.05.18.ADivelbiss not using this, just an idea
const _CART_ITEM = Object.freeze({
  // productID associated this cart item
  productID: "productID",
  // list of parties associated with this cart item
  parties: "parties",
  // list of benes associated with this cart tiem
  benes: "benes",
  // list of payments associated with this cart item
  payments: "payments"
});
export const MM_CART_ITEM = _CART_ITEM;


export const QUESTION_INPUT_TYPE = Object.freeze({
  text: "text",
  textArea: "textArea",
  integer: "integer",
  currency: "currency",
  date: "date",
  time: 'time',
  select: "select",
  radio: "radio",
  radioCheckbox: "radioCheckbox",
  checkbox: "checkbox",
  multiCheckbox: "multiCheckbox",
  email: 'email',
  phone: 'phone',
  ssn: 'ssn',
  zip: 'zip',
  referralCode: 'referralCode',
  idNumber: 'idNumber',
  bankRoutingNumber: 'bankRoutingNumber',
  bankAccountNumber: 'bankAccountNumber',
  unspecified: "unspecified"
});

export const QUESTION_INFO = Object.freeze({
  title: "title",
  content: "content"
});

export const QUESTION_CATEGORY = Object.freeze({
  financial: "financial",
  goals: "goals",
  identity: "identity",
  owner: "owner",
  annuitant: "annuitant",
  beneficiary: "beneficiary",
  payment: "payment",
  acknowledgement: "acknowledgement",
  needs: "needs",
  funds: "funds",
  general: "general",
  confirmation: "confirmation",
  submission: 'submission',
  knockout: 'knockout',
  unspecified: "unspecified"
});

export const QUESTION_SUBCATEGORY = Object.freeze({
  // CATEGORY: owner, annuitant
  primary: "primary",
  joint: "joint",
  
  // CATEGORY: beneficiary
  individual: "individual",
  trust: "trust",
  
  // CATEGORY: payment
  check: "check",
  eft: "eft",
  
  // CATEGORY: Confirmation
  client: "client",
  agent: "agent",
  
  unspecified: "unspecified"
  
});

export const QUESTION_RESPONSE_TYPE = Object.freeze({
  string: "string",
  number: "number",
  boolean: "boolean"
});

export const QUESTION_RESPONSE_VALUE = Object.freeze({
  yes: "Yes",
  no: "No",
  notApplicable: "N/A"
});

export const QUESTION_RESPONSE_CONSTRAINT = Object.freeze({
  // TODO: response constraint types here.
  
  unspecified: "unspecified"
});

// General layout of the question and answers
const _QUESTION_VISUAL_ORIENTATION = Object.freeze({
  horizontal: "horizontal",
  vertical: "vertical"
});
export const QUESTION_VISUAL_ORIENTATION = _QUESTION_VISUAL_ORIENTATION;

export const QUESTION_VISUAL_PRIORITY = Object.freeze({
  lowest: 0,
  veryLow: 0.1,
  low: 0.25,
  medium: 0.5,
  high: 0.75,
  veryHigh: 0.9,
  highest: 1.0
});

export const QUESTION_VISUAL_PRESENCE= Object.freeze({
  smallest: 0,
  verySmall: 0.1,
  small: 0.25,
  normal: 0.5,
  large: 0.75,
  veryLarge: 0.9,
  largest: 1.0
});


const processQuestionCondition = (condition, data) => {
  // check for AND
  if (isValid(condition.AND) && condition.AND.length>0) {
    // short circuit for false
    let result = true;
    for (let i=0; result && i<condition.AND.length; i++) {
      result = processQuestionCondition(condition.AND[i],data);
    }
    return result;
  }
  
  // check for OR
  if (isValid(condition.OR) && condition.OR.length>0) {
    // short circuit for false A || B => !(!A && !B)
    let result = true;
    for (let i=0; result&&i<condition.OR.length; i++) {
      result = !processQuestionCondition(condition.OR[i],data);
    }
    return !result;
  }
  
  // Check for a valid question condition
  if (isValid(condition.key) && isValid(condition.operator) && isValid(condition.value)) {
    const key = condition.key;
    const value = condition.value;
    let result = false;
    switch (condition.operator) {
      case '==':
        result = data[key]===value;
        break;
      case '!=':
        result = data[key]!==value;
        break;
      case '>':
        result = data[key]>value;
        break;
      case '>=':
        result = data[key]>=value;
        break;
      case '<':
        result = data[key]>=value;
        break;
      case '<=':
        result = data[key]>=value;
        break;
      default:
        result = false;
        break;
    }
    // NassauLog(`processQuestionCondition: ${key} ? ${data[key]} ${condition.operator} '${value}' => ${result}`)
    return result;
  }
  
  // If we got here then we could do some kind of default behavior
  // for now return true since the condition is malformed
  return true;
}

const _QUESTION = Object.freeze({
  // Identification
  questionID: "questionID",
  
  // variable name for use in constraints and conditions
  name: "name",

  label: {
    // The question text used to populate the label associated with an input
    text: 'text',

    // Question text justification
    justification: 'justification',

    // Override how many col the question text covers
    colSpan: {
      displayWide: 'displayWide',
      displayNarrow: 'displayNarrow'
    },

    // Given an orientation, set a string classname to be added to QuestionText container
    containerClassname: {
      orientationVertical: 'orientationVertical',
      orientationHorizontal: 'orientationHorizontal'
    },

    // Set the css class for just the label of a question
    textClassname: 'textClassname',

    // This icon must be imported in App.js
    icon: 'icon'
  },

  // Place questions relative to parent questions (Response, Question)
  placement: 'placement',
  
  // The object used for popup helpers and info buttons
  info: "info",
  
  // input type: text, checkbox, etc.
  inputType: "inputType",

  footnote: {
    text: 'text',
    placement: 'placement', // 'Label' or leave out
    justification: 'justification'
  },
  
  // primary question category: financial, owner, beneficiary, annuitant, goals, payment
  category: "category",
  
  // secondary question category: owner.primary, owner.joint, etc.
  subCategory: "subCategory",
  
  // General layout of the question text and answer(s)
  visualOrientation: "visualOrientation",
  
  // [0,1], questions with higher visualPriority would tend toward the top of the page
  // if missing assume 0
  visualPriority: "visualPriority",
  
  // [0,1], questions with higher visualPresence take up more room on the page
  // Could be calculated based on text size and input type.
  // Could help to determine how many questions can fit on a page.
  // if missing assume 0
  visualPresence: "visualPresence",
  
  // {0,1,2,3,4,5} a value controlling the spacing of visual components within the question.
  // default value is 2
  visualSpacing: "visualSpacing",
  
  // an optional array of condition definitions for visibility of the question
  // if no conditions are given then the question will be visible.
  visibilityCondition: "visibilityCondition",
  
  // an optional array of condition definitions for the question to be considered required
  // for the next page advance or submission event.
  // if no conditions are given then question is assumed to be always required. (??)
  requirementConditions: "requirementConditions",
  
  // data type for the response: string, number, boolean, etc.
  responseType: "responseType",

  response: {
    // an array of constraint definitions that limit a valid response
    constraints: "constraints",

    // Override how many col the question response covers
    colSpan: 'colSpan',

    // Override for MultiCheckbox to limit response column
    colCount: 'colCount',

    // Pass responseClass down
    className: 'className',

    // Left, Center, Right justifies responses
    justification: 'justification',

    // Left, Center, Right justifies responses text
    labelJustification: 'labelJustification',
  },

  // questions
  questions: "questions",

  // which control to anchor to (ie Other and Other text)
  anchorTo: "anchorTo",

  // Used for placeholder text
  placeholder: "placeholder",

  // Key is used for question input types that only have one key for multiple values (select)
  key: "key",

  // validateCondition is called and controls a field's disabled prop
  enabledCondition: "enabledCondition"
});
export const MM_QUESTION = _QUESTION;

const _PAYMENT_TYPE  = Object.freeze({
  check: "check",
  bankEFT: "bank",
  rollover: "rollover",
  exchange1035: "1035"
});
export const MM_PAYMENT_TYPE = _PAYMENT_TYPE;

const _PAYMENT = Object.freeze({
  paymentID: "paymentID",
  amount : "amount",
  paymentType : "paymentType"
});
export const MM_PAYMENT = _PAYMENT;

const _PAYMENT_EFT = Object.freeze({
  paymentID: "paymentID",
  amount : "amount",
  paymentType : "paymentType",
  bankName : "bank_name",
  bankRoutingNumber : "bank_routing",
  bankAccountNumber : "bank_accountNum",
  bankAccountNumberConfirm : "bank_confirmNum",
  bankAccountType : "bank_account_type",
  isManualEntry : "isManualEntry",
  payorUid: "payorUid"
});
export const MM_PAYMENT_EFT = _PAYMENT_EFT;

const _PAYMENT_EFT_ACCOUNT_TYPE = Object.freeze({
  checking: "Checking",
  savings: "Savings"
});
export const MM_PAYMENT_EFT_ACCOUNT_TYPE = _PAYMENT_EFT_ACCOUNT_TYPE;

export const MM_ColClassNameForQuestion = (question) => {
  const vSpacing = isValid(question[_QUESTION.visualSpacing]) ? question[_QUESTION.visualSpacing] : 2;
  const vOrientation = isValid(question[_QUESTION.visualOrientation]) ? question[_QUESTION.visualOrientation] : _QUESTION_VISUAL_ORIENTATION.vertical
  const isVertical = vOrientation===_QUESTION_VISUAL_ORIENTATION.vertical;
  let className = "";
  switch (vSpacing) {
    case 0:
      className = isVertical ? "pr-0 pr-sm-1" : "pb-0 pb-sm-1";
      break;
    case 1:
      className = isVertical ? "pr-1 pr-sm-2" : "pb-1 pb-sm-2";
      break;
    case 2:
      className = isVertical ? "pr-2 pr-sm-3" : "pb-2 pb-sm-3";
      break;
    case 3:
      className = isVertical ? "pr-3 pr-sm-4" : "pb-3 pb-sm-4";
      break;
    case 4:
      className = isVertical ? "pr-4 pr-sm-5" : "pb-4 pb-sm-5";
      break;
    case 5:
      className = isVertical ? "pr-5 pr-sm-5" : "pb-5 pb-sm-5";
      break;
    default:
      className = isVertical ? "pr-2 pr-sm-3" : "pb-2 pb-sm-3";
      break;
  }
  return className;
}